export default __webpack_public_path__ + "static/media/right-arrow-head.28a9bc05.svg";